import { render, staticRenderFns } from "./doneAction.vue?vue&type=template&id=b9870510&scoped=true&"
import script from "./doneAction.vue?vue&type=script&lang=js&"
export * from "./doneAction.vue?vue&type=script&lang=js&"
import style0 from "./doneAction.vue?vue&type=style&index=0&id=b9870510&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9870510",
  null
  
)

export default component.exports